/*
 * useDarkMode React Hook
 *
 */

export const useDarkMode = () => {
  const prefersDark =
    typeof window !== `undefined`
      ? window.matchMedia &&
        window.matchMedia("(prefers-color-scheme: dark)").matches
      : null

  if (typeof document !== `undefined`) {
    if (prefersDark) {
      document.body.classList.add("--dark")
    }
  }

  const darkModeToggle = () => {
    document.body.classList.toggle("--dark")
  }

  return { prefersDark, darkModeToggle }
}
